import { Divider } from '@mui/material'

import { BottomCardTitle, ImpactsCardsHor, MediaList, QuillHtmlParser } from 'src/components'
import { ConsumerScansLocations } from 'src/components/consumer-scans-locations'

import { IImpact, IMedia } from 'src/types'
import {
  ContentWrapper,
  ImpactsWrapper,
  NameTitle,
  TitleWrapper,
  ContentSt,
  DescriptionWrapper,
  StyledScrollBtn,
} from './product-card.styled'
import ArrowIcon from 'src/assets/icons/arrow.icon'
import ArrowIconLeft from 'src/assets/icons/arrow.icon-left'
import { useRef } from 'react'
import { useIsTablet } from 'src/hooks'

interface IProps {
  id: string
  aiGenerated: boolean
  accountHolder: string
  accountImage: string
  productName: string
  productDescription: string
  media: IMedia[]
  showMedia: IMedia[]
  impacts: IImpact[]
  isImpactsPage: boolean
  hideAccountName: boolean
  hideProductName: boolean
  accountId: string
  primaryColor: string
  walletAddress: string
  showWalletAddress: boolean
  showBcInfo: boolean
}

export const Content = ({
  id,
  aiGenerated,
  accountHolder,
  accountImage,
  productName,
  productDescription,
  showMedia,
  impacts,
  isImpactsPage,
  hideAccountName,
  hideProductName,
  accountId,
  primaryColor,
  walletAddress,
  showWalletAddress,
  showBcInfo,
}: IProps) => {
  const scrollContainerRef = useRef<HTMLDivElement>(null)
  const isTablet = useIsTablet()
  const scrollLeft = () => {
    if (scrollContainerRef) {
      scrollContainerRef.current.scrollLeft += -130
    }
  }
  const scrollRight = () => {
    if (scrollContainerRef) {
      scrollContainerRef.current.scrollLeft += 130
    }
  }

  return (
    <ContentSt id="content-component__components-product-card__contentst__l73">
      <ContentWrapper id="content-component__components-product-card__contentwrapper__l74">
        <TitleWrapper id="content-component__components-product-card__titlewrapper__l75">
          <BottomCardTitle
            hideAccountName={hideAccountName}
            twitterTitle={productName}
            title={accountHolder}
            image={accountImage}
            accountId={accountId}
            avatarSx={{ borderRadius: '20%' }}
          />
        </TitleWrapper>
        {!hideProductName && (
          <NameTitle id="content-component__components-product-card__nametitle__l84" variant="h2">
            {productName}
          </NameTitle>
        )}
        {productDescription && productDescription !== '<p><br></p>' ? (
          <>
            <DescriptionWrapper id="content-component__components-product-card__descriptionwrapper__l87">
              <QuillHtmlParser html={productDescription} />
            </DescriptionWrapper>
            <Divider
              id="content-component__components-product-card__divider__l90"
              sx={{ borderColor: 'rgba(0,0,0,0.08);' }}
            />
          </>
        ) : null}
        {showMedia.length > 0 && (
          <>
            <MediaList media={showMedia} />
            <Divider
              id="content-component__components-product-card__divider__l96"
              sx={{ borderColor: 'rgba(0,0,0,0.08);' }}
            />
          </>
        )}
      </ContentWrapper>
      <ImpactsWrapper id="content-component__components-product-card__impactswrapper__l100">
        <StyledScrollBtn
          id="content-component__components-product-card__styledscrollbtn__l101"
          onClick={scrollLeft}
          style={{ display: isTablet || impacts.length < 6 ? 'none' : '' }}
        >
          <ArrowIconLeft />
        </StyledScrollBtn>
        {impacts.length > 0 && (
          <ImpactsCardsHor
            items={impacts}
            ref={scrollContainerRef}
            withArrows={!(isTablet || impacts.length < 6)}
            primaryColor={primaryColor}
            walletAddress={walletAddress}
            showWalletAddress={showWalletAddress}
            showBcInfo={showBcInfo}
            accountImage={accountImage}
            isImpactsPage={isImpactsPage}
          />
        )}
        <StyledScrollBtn
          id="content-component__components-product-card__styledscrollbtn__l120"
          onClick={scrollRight}
          style={{ display: isTablet || impacts.length < 6 ? 'none' : '' }}
        >
          <ArrowIcon />
        </StyledScrollBtn>
      </ImpactsWrapper>

      {aiGenerated && <ConsumerScansLocations productId={id} />}
    </ContentSt>
  )
}
